import { render, staticRenderFns } from "./TradeInput.vue?vue&type=template&id=1979f1f3&"
import script from "./TradeInput.vue?vue&type=script&lang=js&"
export * from "./TradeInput.vue?vue&type=script&lang=js&"
import style0 from "./TradeInput.vue?vue&type=style&index=0&id=1979f1f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports